import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

const Svg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      d="M823.5 169.7v687.4h-623V169.7h623m10.7-70.1l-644.3 0.1c-32.8 0-59.4 26.5-59.4 59.3v708.7c0 15.7 6.3 30.8 17.4 42 11.1 11.2 26.2 17.4 42 17.4h644.4c15.7 0 30.8-6.3 41.9-17.4 11.1-11.1 17.3-26.2 17.3-42V158.9c0-32.7-26.5-59.3-59.3-59.3z"
      fill="currentColor"
    />
    <path
      d="M666.6 461.1h-306c-16.5 0-30-13.5-30-30v-18c0-16.5 13.5-30 30-30h306c16.5 0 30 13.5 30 30v18c0 16.5-13.5 30-30 30zM666.6 639.6h-306c-16.5 0-30-13.5-30-30v-18c0-16.5 13.5-30 30-30h306c16.5 0 30 13.5 30 30v18c0 16.5-13.5 30-30 30z"
      fill="currentColor"
    />
  </svg>
)

const IconComponent = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
)

export default IconComponent